import Apply from "../components/contacts/apply";
import OtherContacts from "../components/contacts/other-contacts";

function Contacts() {
    return ( 
        <>
            <Apply />
            <OtherContacts />
        </>
     );
}

export default Contacts;